import React from 'react';
import'./linksmrsool.css';
const Linksmrsool = () => {
  return (
    <div className='container'>
      <h1>Tools Links </h1>
      <div className='links'>
      <ul>
        <li><a href='https://app.intercom.com/a/inbox/xum7ms95/inbox/admin/7338339/conversation/9130698?view=List'>Intercom</a></li>
        <li><a href='https://backend.mrsool.co/'>Backend</a></li>
        <li><a href='https://chrome.google.com/webstore/detail/support-agent-sidekiq-too/mlliganbblajdklbldndkfkkidhjkmgl/related?hl=en&authuser=5'>Intercom Extension</a></li>
        <li><a href='https://app.slack.com/client/T11E9QXP1/C0658FR0Q5P'>Slack</a></li>
        <li><a href='https://portal.maqsam.com/en/sign-in'>Maqsam</a></li>
        <li><a href='https://docs.google.com/forms/d/e/1FAIpQLSeCIhhWFwjyTAc6rTJdv6O7rD3l4eIxaHgj9_3G3BXRTnN_Zg/viewform'>Live Tracker Stores
        </a></li>
        <li><a href='https://docs.google.com/forms/d/e/1FAIpQLSdvMnYM5Lu_HTWfkMEKRsI-9LCf9WfcbKiTYoOF9Q-vH1v_2g/viewform '>Partner issues
        </a></li>
        <li><a href='https://docs.google.com/forms/d/e/1FAIpQLSdD5iukRPNPWHem9UNjX7vnb7D2dVUPGnSLHuN5cu5C1ifi1w/viewform '> بيانات المرسول / العميل
        </a></li>
        <li><a href='https://www.google.com/maps/dir///@31.224111,29.954886,11z?hl=ar&entry=ttu&g_ep=EgoyMDI0MTAxMy4wIKXMDSoASAFQAw%3D%3D '>Google map</a></li>
        <li><a href='https://www.google.com/maps/d/u/0/viewer?mid=1eWoCpGMgCcgWljcnHpG5nXyIvCkG9QA&ll=30.143798559472838%2C31.32911258932647&z=10 '>EG-MAPS</a></li>
      </ul>
      </div>

    </div>
  );
}

export default Linksmrsool;
